import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=33d3513e&scoped=true"
import script from "./StudentsTable.vue?vue&type=script&lang=ts"
export * from "./StudentsTable.vue?vue&type=script&lang=ts"
import style0 from "./StudentsTable.vue?vue&type=style&index=0&id=33d3513e&prod&lang=scss&scoped=true"
import style1 from "./StudentsTable.vue?vue&type=style&index=1&id=33d3513e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3513e",
  null
  
)

export default component.exports